import { checkFeaturePermission } from '../../utils/featureUtils';
import { RouteConfig, protectedRouteList } from '../../routes/routesConfig';
import { permission } from '../../constants/permission';

type NavMenuItem = RouteConfig & { subMenu?: any[] };

export const menuItems = (): NavMenuItem[] => {
  let accountSettingsSubMenu = [
    {
      ...protectedRouteList.organizationSetup,
    },
    {
      ...protectedRouteList.userSetup,
    },
  ];

  if (
    (checkFeaturePermission(permission.READ_ORG_SETUP) ||
      checkFeaturePermission(permission.WRITE_ORG_SETUP)) &&
    checkFeaturePermission(permission.WRITE_USER)
  ) {
    accountSettingsSubMenu = [];
  }

  return [
    {
      ...protectedRouteList.swapBaskets,
    },
    {
      ...protectedRouteList.orderEntry,
    },
    {
      ...protectedRouteList.dashboard,
    },
    ...accountSettingsSubMenu,
    // {
    //   ...protectedRouteList.exceptionQueue,
    // },
  ];
};
